import gql from "graphql-tag"

export const DELETE_CUSTOM_PAYMENT_CONFIG = gql`
  mutation deleteCustomPaymentConfig($id: ID!) {
    deleteCustomPaymentConfig(id: $id) {
      status
    }
  }
`
